"use client";

import { useEffect } from "react";

import { Button } from "@/components/ui/button";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Portal error boundary", error);
  }, [error]);

  return (
    <div className="no-scroll-desktop mx-auto flex min-h-screen max-w-3xl flex-col items-start justify-center gap-4 px-6 py-10 lg:h-[100dvh] lg:py-8">
      <p className="text-xs uppercase tracking-wider text-muted-foreground">Dobbix Portal</p>
      <h1 className="text-2xl font-semibold text-foreground">Something went wrong</h1>
      <p className="text-sm text-muted-foreground">
        An unexpected error occurred while loading this page. Please try again.
      </p>
      {error.digest ? (
        <p className="text-xs text-muted-foreground">Error digest: {error.digest}</p>
      ) : null}
      <Button onClick={reset}>Try again</Button>
    </div>
  );
}
